import { hookstate } from "@hookstate/core";

export const MessageState = hookstate({deleted:[],unread:0});
